import {getAxios} from "../axios";
import {addParam, errorCatch, getNotificationId, getTokenHeaders} from "../helper";
import {
  ENDPOINT_PACKAGE_ELIGIBLE_OWNERS,
  ENDPOINT_ORGANIZATION_PACKAGE_GROUPS,
  ENDPOINT_PACKAGES,
  ENDPOINT_PACKAGE_TRANSFER_OWNER,
  ENDPOINT_PACKAGE_TRANSFER_GROUP
} from "../../config/endpoints";
import {Messages} from "../../config";
import { store } from "../../store/store";
import { NOTIFICATION_SUCCESS } from "../../store/actions/types";
import { displayNotification } from "../../store/actions/notification";

export function getPackages(payload) {
  if (payload && payload.disablePagination === true) {
    if (! payload.pagination) {
      payload.pagination = {};
    }

    payload.pagination.per_page = 100000;
  }

  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_PACKAGES,
      {
        '{package}': '',
      }
    ),
    getTokenHeaders(payload?.pagination || null)
  )
    .then(response => {
      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        });

        return e.response;
      }
    );
}

/**
 * Get details of package
 * @param {object} payload
 * @param {string} payload.packageId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function getPackageDetails(payload) {

  return getAxios().get(
    addParam(
      ENDPOINT_PACKAGES,
      {
        '{package}': payload.packageId,
      }
    ),
    getTokenHeaders(payload?.pagination || null)
  )
    .then( response => {
      return response && response.data ? response.data : null
    } )
    .catch(
      e => {
        errorCatch( e, {
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload) );

        return e.response;
      }
    );
}

/**
 * Get package groups for a client organization.
 * @param {object} payload
 * @param {string} payload.organizationId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function getOrganizationPackageGroups(payload) {
  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_ORGANIZATION_PACKAGE_GROUPS,
      {
        '{organization}': payload.organizationId,
      }
    ),
    getTokenHeaders(payload?.forTransferPackage ? { forTransferPackage: payload.forTransferPackage } : null)
  )
    .then(response => {
      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload));

        return e.response;
      }
    );
}

/**
 * Get users eligible to become package owner.
 * @param {object} payload
 * @param {string} payload.packageId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function getEligiblePackageOwners(payload) {
  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_PACKAGE_ELIGIBLE_OWNERS,
      {
        '{package}': payload.packageId,
      }
    ),
    getTokenHeaders()
  )
    .then(response => {
      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload));

        return e.response;
      }
    );
}

/**
 * Transfer package ownership to another user.
 * @param {object} payload
 * @param {string} payload.packageId
 * @param {string} payload.newUserId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function transferPackageOwner(payload) {
  return getAxios().put(
    addParam(
      ENDPOINT_PACKAGE_TRANSFER_OWNER,
      {
        '{package}': payload.packageId,
      }
    ),
    { new_user_id: payload.newUserId },
    getTokenHeaders()
  )
    .then(response => {
      if (response?.data) {
        store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.UPDATE_RESOURCE_SUCCESS, payload.notificationId || null));
      }

      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload));

        return e.response;
      }
    );
}

/**
 * Transfer a package to a different package group.
 * @param {object} payload
 * @param {string} payload.packageId
 * @param {string} payload.newPackageGroupId
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function transferPackageGroup(payload) {
  return getAxios().put(
    addParam(
      ENDPOINT_PACKAGE_TRANSFER_GROUP,
      {
        '{package}': payload.packageId,
      }
    ),
    { new_package_group_id: payload.newPackageGroupId },
    getTokenHeaders()
  )
    .then(response => {
      if (response?.data) {
        store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.UPDATE_RESOURCE_SUCCESS, payload.notificationId || null));
      }

      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload));

        return e.response;
      }
    );
}
